import PrepaymentReadyDriverCardContainer from './PrepaymentReadyDriverCardContainer';

export default PrepaymentReadyDriverCardContainer;
